import { ChildReportsRoutingModule } from './child-reports-routing.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AcademicRiskReportComponent } from './academic-risk-report/academic-risk-report.component';
import { CommunicationEventReportComponent } from './communication-event-report/communication-event-report.component';
import { CountsComponent } from './counts/counts.component';
import { GraduationReportComponent } from './graduation-report/graduation-report.component';
import { InaReportComponent } from './ina-report/ina-report.component';
import { PfsReportComponent } from './pfs-report/pfs-report.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MaterialModule } from '../../../app/material/material.module';

import { PipesModule } from '../../../app/pipes/pipes.module';
import { CommonComponentsModule } from '../common-components/common-components.module';
import { EnrollmentReportComponent } from './enrollment-report/enrollment-report.component';
import { ServiceReportComponent } from './service-report/service-report.component';
import { ServiceAdministrationModule } from '../service-administration/service-administration.module';
import { ServiceReportStudentsComponent } from './service-report/service-report-students/service-report-students.component';
import { ChildrenModule } from '../children/children.module';
import { CountsChildrenModalComponent } from './counts/counts-children-modal/counts-children-modal.component';
import { ServiceInfoComponent } from './service-report/service-info/service-info.component';

@NgModule({
    declarations: [
        CountsComponent,
        GraduationReportComponent,
        AcademicRiskReportComponent,
        PfsReportComponent,
        CommunicationEventReportComponent,
        InaReportComponent,
        EnrollmentReportComponent,
        ServiceReportComponent,
        ServiceReportStudentsComponent,
        CountsChildrenModalComponent,
        ServiceInfoComponent
    ],
    imports: [
        CommonModule,
        MaterialModule,
        ReactiveFormsModule,
        FormsModule,
        PipesModule,
        CommonComponentsModule,
        ServiceAdministrationModule,
        ChildReportsRoutingModule,
        ChildrenModule
    ],
    providers: []
})
export class ChildReportsModule {}
